import { useFetchBondPreviews } from "@portal/api/previews";
import { FilterableDataTable } from "@portal/components/ui/FilterableDataTable";
import { useIsMinimalBondUIEnabled } from "@portal/hooks/useIsMinimalBondUIEnabled";
import { FC, useMemo } from "react";
import { getBondTableColumns } from "./columns";

export const BondPreviewsClosed: FC = () => {
	const { bondPreviews } = useFetchBondPreviews();
	const isMinimalUIEnabled = useIsMinimalBondUIEnabled();

	const closedBondPreviews = useMemo(
		() => bondPreviews?.filter((preview) => preview.status === "closed"),
		[bondPreviews],
	);
	const columns = useMemo(() => getBondTableColumns(isMinimalUIEnabled), [isMinimalUIEnabled]);

	return (
		<FilterableDataTable
			name="bonds_closed"
			columnDefs={columns}
			getRowUrl={(row) => `/bonds/${row.id}`}
			data={closedBondPreviews}
			loadingMessage="Loading bonds..."
			enableExportToCSV
		/>
	);
};
